/* TODO(ASIMO-2105): cherrera2@ to remove once experiment is over regardless of outcome */

/**
 * Retrieves and parses a value from localStorage
 * @param key - The localStorage key to retrieve
 * @returns The parsed value of type T, or null if the key doesn't exist or parsing fails
 */
export function getItem<T = any>(key: string): T | null {
	try {
		const value = window.localStorage.getItem(key);
		if (value === null) {
			return null;
		}
		return JSON.parse(value) as T;
	} catch (_) {
		return null;
	}
}

/**
 * Stores a value in localStorage by serializing it to JSON
 * @param key - The localStorage key to store the value under
 * @param value - The value to store (will be JSON stringified)
 */
export function setItem<T = any>(key: string, value: T): void {
	try {
		window.localStorage.setItem(key, JSON.stringify(value));
	} catch (_) {
		return;
	}
}

/**
 * Removes a key-value pair from localStorage
 * @param key - The localStorage key to remove
 */
export function removeItem(key: string): void {
	try {
		window.localStorage.removeItem(key);
	} catch (_) {
		return;
	}
}
